"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCuratedSearch = exports.ADMIN_CURATED_SEARCH_KEYS = exports.ADMIN_EMAIL_TEMPLATES = exports.ADMIN_ROLE_REPORT_COLUMN_MAPPING = exports.SEARCH_FILTERS = exports.ADMIN_ACTIVITY_TYPES = exports.DELIVERY_PROBLEM_LEVEL_URL_PARAM_VALUES = exports.ADMIN_PAGE_URL_PARAM = exports.ADMIN_PROBLEM_FILTER_URL_PARAM = exports.ADMIN_STATUS_PATHS = exports.DELIVERY_PROBLEM_LEVEL_OPTION_MAP = exports.NOT_ASSIGNED_FILTERS = exports.NOT_ASSIGNABLE_PROBLEM_TYPES = exports.DELIVERY_PROBLEM_LEVEL_OPTIONS = exports.DELIVERY_PROBLEM_LEVELS = exports.CUSTOM_ADMIN_STATUSES = exports.ADMIN_STATUS_OTHER_CHANGE_MAP = exports.ADMIN_STATUS_CHANGE_MAP = exports.ADMIN_STATUSES_BY_ROLE = exports.ADMIN_REVIEW_STATUSES = exports.ADMIN_STATUSES = void 0;
const user_1 = require("../../user");
var ADMIN_STATUSES;
(function (ADMIN_STATUSES) {
    ADMIN_STATUSES["inProgress"] = "inProgress";
    ADMIN_STATUSES["waitingForDocument"] = "waitingForDocument";
    ADMIN_STATUSES["toPrepare"] = "toPrepare";
    ADMIN_STATUSES["pending"] = "pending";
    ADMIN_STATUSES["toSend"] = "toSend";
    ADMIN_STATUSES["completed"] = "completed";
})(ADMIN_STATUSES = exports.ADMIN_STATUSES || (exports.ADMIN_STATUSES = {}));
var ADMIN_REVIEW_STATUSES;
(function (ADMIN_REVIEW_STATUSES) {
    ADMIN_REVIEW_STATUSES["waitingForReview"] = "waitingForReview";
    ADMIN_REVIEW_STATUSES["hasBeenReviewed"] = "hasBeenReviewed";
    ADMIN_REVIEW_STATUSES["hasSeenReview"] = "hasSeenReview";
})(ADMIN_REVIEW_STATUSES = exports.ADMIN_REVIEW_STATUSES || (exports.ADMIN_REVIEW_STATUSES = {}));
exports.ADMIN_STATUSES_BY_ROLE = {
    [user_1.ADMIN_ROLES.manager]: {
        toPrepare: ADMIN_STATUSES.toPrepare,
        pending: ADMIN_STATUSES.pending,
        toSend: ADMIN_STATUSES.toSend,
        completed: ADMIN_STATUSES.completed,
    },
    [user_1.ADMIN_ROLES.producer]: {
        inProgress: ADMIN_STATUSES.inProgress,
        waitingForDocument: ADMIN_STATUSES.waitingForDocument,
        pending: ADMIN_STATUSES.pending,
        completed: ADMIN_STATUSES.completed,
    },
    // Same as "superAdmin"
    [user_1.ADMIN_ROLES.supervisor]: {
        inProgress: ADMIN_STATUSES.inProgress,
        waitingForDocument: ADMIN_STATUSES.waitingForDocument,
        pending: ADMIN_STATUSES.pending,
        toSend: ADMIN_STATUSES.toSend,
        completed: ADMIN_STATUSES.completed,
    },
    // Same as "supervisor"
    [user_1.ADMIN_ROLES.superAdmin]: {
        inProgress: ADMIN_STATUSES.inProgress,
        waitingForDocument: ADMIN_STATUSES.waitingForDocument,
        pending: ADMIN_STATUSES.pending,
        toSend: ADMIN_STATUSES.toSend,
        completed: ADMIN_STATUSES.completed,
    },
};
/**
 * OverlayAdminStatus currently assumes there is always only one possible change even
 * if it returns an array.
 */
exports.ADMIN_STATUS_CHANGE_MAP = {
    [user_1.ADMIN_ROLES.producer]: {
        [ADMIN_STATUSES.inProgress]: [ADMIN_STATUSES.toPrepare],
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.inProgress],
    },
    [user_1.ADMIN_ROLES.manager]: {
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.inProgress],
    },
    // Same as "superAdmin"
    [user_1.ADMIN_ROLES.supervisor]: {
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.inProgress],
    },
    // Same as "supervisor"
    [user_1.ADMIN_ROLES.superAdmin]: {
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.inProgress],
    },
};
/**
 * Other ways of changing the status that are allowed, but using different ways than the
 * editable admin status in the "General" page.
 */
exports.ADMIN_STATUS_OTHER_CHANGE_MAP = {
    [user_1.ADMIN_ROLES.producer]: {
        [ADMIN_STATUSES.inProgress]: [
            ADMIN_STATUSES.pending,
            ADMIN_STATUSES.toPrepare,
            ADMIN_STATUSES.waitingForDocument,
        ],
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.pending, ADMIN_STATUSES.waitingForDocument],
        [ADMIN_STATUSES.pending]: [ADMIN_STATUSES.toPrepare, ADMIN_STATUSES.inProgress],
    },
    [user_1.ADMIN_ROLES.manager]: {
        [ADMIN_STATUSES.inProgress]: [
            ADMIN_STATUSES.pending,
            ADMIN_STATUSES.toPrepare,
            ADMIN_STATUSES.waitingForDocument,
        ],
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.pending, ADMIN_STATUSES.waitingForDocument],
        [ADMIN_STATUSES.pending]: [ADMIN_STATUSES.toPrepare, ADMIN_STATUSES.inProgress],
    },
    // Same as "superAdmin"
    [user_1.ADMIN_ROLES.supervisor]: {
        [ADMIN_STATUSES.inProgress]: [
            ADMIN_STATUSES.pending,
            ADMIN_STATUSES.toPrepare,
            ADMIN_STATUSES.waitingForDocument,
        ],
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.pending, ADMIN_STATUSES.waitingForDocument],
        [ADMIN_STATUSES.pending]: [ADMIN_STATUSES.toPrepare, ADMIN_STATUSES.inProgress],
    },
    // Same as "supervisor"
    [user_1.ADMIN_ROLES.superAdmin]: {
        [ADMIN_STATUSES.inProgress]: [
            ADMIN_STATUSES.pending,
            ADMIN_STATUSES.toPrepare,
            ADMIN_STATUSES.waitingForDocument,
        ],
        [ADMIN_STATUSES.toPrepare]: [ADMIN_STATUSES.pending, ADMIN_STATUSES.waitingForDocument],
        [ADMIN_STATUSES.pending]: [ADMIN_STATUSES.toPrepare, ADMIN_STATUSES.inProgress],
    },
};
var CUSTOM_ADMIN_STATUSES;
(function (CUSTOM_ADMIN_STATUSES) {
    CUSTOM_ADMIN_STATUSES["notAssigned"] = "notAssigned";
})(CUSTOM_ADMIN_STATUSES = exports.CUSTOM_ADMIN_STATUSES || (exports.CUSTOM_ADMIN_STATUSES = {}));
exports.DELIVERY_PROBLEM_LEVELS = [0, 1, 2];
var DELIVERY_PROBLEM_LEVEL_OPTIONS;
(function (DELIVERY_PROBLEM_LEVEL_OPTIONS) {
    DELIVERY_PROBLEM_LEVEL_OPTIONS["none"] = "none";
    DELIVERY_PROBLEM_LEVEL_OPTIONS["level1"] = "level1";
    DELIVERY_PROBLEM_LEVEL_OPTIONS["level2"] = "level2";
    DELIVERY_PROBLEM_LEVEL_OPTIONS["level3"] = "level3";
})(DELIVERY_PROBLEM_LEVEL_OPTIONS = exports.DELIVERY_PROBLEM_LEVEL_OPTIONS || (exports.DELIVERY_PROBLEM_LEVEL_OPTIONS = {}));
var NOT_ASSIGNABLE_PROBLEM_TYPES;
(function (NOT_ASSIGNABLE_PROBLEM_TYPES) {
    NOT_ASSIGNABLE_PROBLEM_TYPES["none"] = "none";
    NOT_ASSIGNABLE_PROBLEM_TYPES["invalidCustomerStatus"] = "invalidCustomerStatus";
    NOT_ASSIGNABLE_PROBLEM_TYPES["invalidAdminStatus"] = "invalidAdminStatus";
    NOT_ASSIGNABLE_PROBLEM_TYPES["noTaxDocumentId"] = "noTaxDocumentId";
    NOT_ASSIGNABLE_PROBLEM_TYPES["invalidHasSelfEmployedWithExpenses"] = "invalidHasSelfEmployedWithExpenses";
    NOT_ASSIGNABLE_PROBLEM_TYPES["invalidHasRentalBuilding"] = "invalidHasRentalBuilding";
})(NOT_ASSIGNABLE_PROBLEM_TYPES = exports.NOT_ASSIGNABLE_PROBLEM_TYPES || (exports.NOT_ASSIGNABLE_PROBLEM_TYPES = {}));
var NOT_ASSIGNED_FILTERS;
(function (NOT_ASSIGNED_FILTERS) {
    NOT_ASSIGNED_FILTERS["none"] = "none";
    NOT_ASSIGNED_FILTERS["notAssignable"] = "notAssignable";
})(NOT_ASSIGNED_FILTERS = exports.NOT_ASSIGNED_FILTERS || (exports.NOT_ASSIGNED_FILTERS = {}));
exports.DELIVERY_PROBLEM_LEVEL_OPTION_MAP = {
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.none]: null,
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.level1]: exports.DELIVERY_PROBLEM_LEVELS[0],
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.level2]: exports.DELIVERY_PROBLEM_LEVELS[1],
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.level3]: exports.DELIVERY_PROBLEM_LEVELS[2],
};
exports.ADMIN_STATUS_PATHS = {
    [CUSTOM_ADMIN_STATUSES.notAssigned]: 'not-assigned',
    [ADMIN_STATUSES.inProgress]: 'in-progress',
    [ADMIN_STATUSES.waitingForDocument]: 'waiting-for-document',
    [ADMIN_STATUSES.toPrepare]: 'to-prepare',
    [ADMIN_STATUSES.pending]: 'pending',
    [ADMIN_STATUSES.toSend]: 'to-send',
    [ADMIN_STATUSES.completed]: 'completed',
};
exports.ADMIN_PROBLEM_FILTER_URL_PARAM = 'problem';
exports.ADMIN_PAGE_URL_PARAM = 'page';
exports.DELIVERY_PROBLEM_LEVEL_URL_PARAM_VALUES = {
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.none]: '0',
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.level1]: '1',
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.level2]: '2',
    [DELIVERY_PROBLEM_LEVEL_OPTIONS.level3]: '3',
};
var ADMIN_ACTIVITY_TYPES;
(function (ADMIN_ACTIVITY_TYPES) {
    ADMIN_ACTIVITY_TYPES["adminStatusChange"] = "adminStatusChange";
    ADMIN_ACTIVITY_TYPES["adminReviewStatusChange"] = "adminReviewStatusChange";
    ADMIN_ACTIVITY_TYPES["producerChange"] = "producerChange";
    ADMIN_ACTIVITY_TYPES["managerChange"] = "managerChange";
    ADMIN_ACTIVITY_TYPES["pdfJobStart"] = "pdfJobStart";
    ADMIN_ACTIVITY_TYPES["note"] = "note";
    ADMIN_ACTIVITY_TYPES["helpMessage"] = "helpMessage";
    ADMIN_ACTIVITY_TYPES["signature"] = "signature";
    ADMIN_ACTIVITY_TYPES["documentAddedAfterPurchase"] = "documentAddedAfterPurchase";
    ADMIN_ACTIVITY_TYPES["sendDeclarationsStart"] = "sendDeclarationsStart";
    ADMIN_ACTIVITY_TYPES["sendDeclarationsFailure"] = "sendDeclarationsFailure";
})(ADMIN_ACTIVITY_TYPES = exports.ADMIN_ACTIVITY_TYPES || (exports.ADMIN_ACTIVITY_TYPES = {}));
/**
 * @see https://docs-v3.strapi.io/developer-docs/latest/developer-resources/content-api/content-api.html#filters
 * @see https://docs-v3.strapi.io/developer-docs/latest/development/backend-customization.html#queries
 */
exports.SEARCH_FILTERS = {
    equalTo: 'eq',
    notEqualTo: 'ne',
    lessThan: 'lt',
    greaterThan: 'gt',
    lessThanOrEqualTo: 'lte',
    greaterThanOrEqualTo: 'gte',
    in: 'in',
    notIn: 'nin',
    contains: 'contains',
    doesntContain: 'ncontains',
    containsCaseSensitive: 'containss',
    doesntContainCaseSensitive: 'ncontainss',
    null: 'null', // Is null or not null (true or false)
};
// TEMPORARY MAPPING
exports.ADMIN_ROLE_REPORT_COLUMN_MAPPING = {
    [user_1.ADMIN_ROLES.superAdmin]: user_1.ADMIN_ROLES.producer,
    [user_1.ADMIN_ROLES.supervisor]: user_1.ADMIN_ROLES.manager,
};
var ADMIN_EMAIL_TEMPLATES;
(function (ADMIN_EMAIL_TEMPLATES) {
    ADMIN_EMAIL_TEMPLATES["missingDocumentsInfos"] = "missingDocumentsInfos";
    ADMIN_EMAIL_TEMPLATES["simpleExplanation"] = "simpleExplanation";
    // passwordProtectedDocuments = 'passwordProtectedDocuments',
    // freeMessage = 'freeMessage',
})(ADMIN_EMAIL_TEMPLATES = exports.ADMIN_EMAIL_TEMPLATES || (exports.ADMIN_EMAIL_TEMPLATES = {}));
var ADMIN_CURATED_SEARCH_KEYS;
(function (ADMIN_CURATED_SEARCH_KEYS) {
    ADMIN_CURATED_SEARCH_KEYS["reportId"] = "reportId";
    ADMIN_CURATED_SEARCH_KEYS["orderId"] = "orderId";
    ADMIN_CURATED_SEARCH_KEYS["phone"] = "phone";
    ADMIN_CURATED_SEARCH_KEYS["email"] = "email";
    ADMIN_CURATED_SEARCH_KEYS["name"] = "name";
    ADMIN_CURATED_SEARCH_KEYS["text"] = "text";
})(ADMIN_CURATED_SEARCH_KEYS = exports.ADMIN_CURATED_SEARCH_KEYS || (exports.ADMIN_CURATED_SEARCH_KEYS = {}));
function isCuratedSearch(whereArgs) {
    for (const key in ADMIN_CURATED_SEARCH_KEYS) {
        if (key in whereArgs)
            return true;
    }
    return false;
}
exports.isCuratedSearch = isCuratedSearch;
//# sourceMappingURL=admin.js.map